import AsideMenu from './AsideMenu.vue'

export default AsideMenu


// WEBPACK FOOTER //
// ./src/layouts/AsideMenu/index.js